import React from 'react'
import { GrowthWheelUserForReview } from '../../redux/growth-wheel.endpoints'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

interface AdminContributorListProps {
  contributors: GrowthWheelUserForReview[]
  onSelectContributor: (contributorId: number) => void
}

export function AdminContributorList({
  contributors,
  onSelectContributor,
}: AdminContributorListProps) {
  return (
    <div className="gw-admin-list-container">
      {/* Header */}
      <div className="mb-4">
        <h1 className="gw-admin-list-title">Growth Wheel - Admin View</h1>
        <p className="gw-admin-list-subtitle">
          Review and assess competencies for your team members.
        </p>
      </div>

      {/* Contributors List */}
      <div>
        <div className="gw-admin-list-header">
          <h2 className="gw-admin-list-section-title">Team Members</h2>
          <span className="gw-admin-list-count">
            {contributors.length} contributors
          </span>
        </div>

        <div className="gw-admin-contributor-list">
          {contributors.map(contributor => {
            const percentage =
              contributor.totalEvaluations > 0
                ? Math.round(
                    (contributor.evaluationsDone /
                      contributor.totalEvaluations) *
                      100,
                  )
                : 0

            return (
              <button
                key={contributor.id}
                onClick={() => onSelectContributor(contributor.id)}
                className="gw-admin-contributor-card"
              >
                <div className="gw-admin-card-content">
                  <div className="gw-admin-card-main">
                    <div className="gw-admin-avatar">
                      <FontAwesomeIcon icon={faUser} />
                    </div>

                    <div className="gw-admin-info">
                      <h3 className="gw-admin-name">
                        {contributor.firstName} {contributor.lastName}
                      </h3>
                      <p className="gw-admin-role">{contributor.area}</p>
                      <div className="gw-admin-progress-container">
                        <div className="gw-admin-progress-bar">
                          <div
                            className="gw-admin-progress-fill"
                            style={{ width: `${percentage}%` }}
                          />
                        </div>
                        <span className="gw-admin-progress-text">
                          {contributor.evaluationsDone}/
                          {contributor.totalEvaluations}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="gw-admin-chevron">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </div>
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
